import React, { forwardRef } from 'react'
import '../Post.css'
import { Avatar } from '@mui/material'
import { BarChart, BookmarkBorderOutlined, ChatBubbleOutlineRounded, FavoriteBorder, PublishRounded, RepeatRounded, Verified } from '@mui/icons-material'

function Post( {avatar, displayName, userName, verified, caption, media}) {
  return (
    <div className='post'>
        <div className="post__avatar">
            <Avatar src={avatar} />
        </div>
        <div className="post__content">
        <div className="post__body">
            <div className="post__header">
                <div className="post__headerPerson">
                    <h2>
                        {displayName} {verified && <span><Verified fontSize='small' className="post__badge" /></span>}
                        <span className='post__userName'> @{userName} •</span>
                    </h2>
                </div>
                <div className="post__headerCaption">
                    <p>{caption}</p>
                </div>
            </div>
            {media &&
            <img className="post__media" src={media} alt="gif" />}
            <div className="post__foot">
                <div className="post__foot__left">
                <ChatBubbleOutlineRounded fontSize='small' />
                <RepeatRounded fontSize='small' />
                <FavoriteBorder fontSize='small' />
                <BarChart fontSize='small' />
                </div>
                <div className="post__foot__right">
                <BookmarkBorderOutlined fontSize='small' />
                <PublishRounded fontSize='small' />
                </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Post